import { useTranslation } from 'react-i18next';
import { TTab } from '../../utils';
import style from './PublishButton.module.scss';
import externalIcon from '../../assets/pictures/icons/external-icon.svg';
import { useEffect, useState } from 'react';
import { trackClickStartStream, trackPrompt, trackPublish, trackSelectedAvatar, trackSelectedBackground, trackSelectedVoice, trackUserChangePrompt, trackUserTimeInApp } from '../../utils/analyticsTracker';
import { useSelector } from 'react-redux';
import { IRootState } from '../../redux/store';
import { calculateSessionDuration } from '../../utils/cookieUtils';

type Props = {
  activeTab: TTab;
  openPublishButton: () => void;
};

export const PublishButton = ({ activeTab, openPublishButton }: Props) => {
    const { t } = useTranslation('general');
    const [showShowPublishButton, setShowPublishButton] = useState<boolean>(false);
    const formData = useSelector((state: IRootState) => state.avatarForm);
    const avatar = useSelector((state: IRootState) => state.avatar);
    const { t: tForm } = useTranslation("form");
    const defaultPrompt = tForm(avatar.promptKey, {name: avatar.name});
    const isUserChangedPrompt = defaultPrompt === formData.prompt;

    useEffect(() => {
        if (!window) return;
        const handleMessage = (event: MessageEvent) => {
            if (event.data?.type === 'STREAM_STARTED') {
                setShowPublishButton(true);
            } else if (event.data?.type === 'CLICK_ON_START') {
                trackClickStartStream();
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    useEffect(() => {
        if (activeTab !== 'preview') {
            setShowPublishButton(false);
        }
    }, [activeTab]);

    const handlePublishClick = () => {
        openPublishButton();
        const userSessionTime = calculateSessionDuration();
        if (userSessionTime) {
			trackUserTimeInApp(userSessionTime);
		}
        trackPublish();
        trackPrompt(formData.prompt);
        trackSelectedAvatar(formData.type);
        trackSelectedVoice(`voice id: ${formData.voice}, ttsEngine: ${formData.ttsEngine}`);
        trackSelectedBackground(formData.scene);
        trackUserChangePrompt(isUserChangedPrompt ? "no" : "yes");
    };

  return (
      <button className={`${style.publishButton} ${showShowPublishButton ? style.visible : style.hidden}`} type='button' onClick={handlePublishClick} disabled={!showShowPublishButton}>
        <img src={externalIcon} alt='External link icon' className={style.publishButtonImg} />
        <span className={style.publishButtonText}>{t("publish")}</span>
      </button>
  );
};